/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { Stack } from '@atlaskit/primitives';
import { messages } from '../../../../messages';
import RelatedLinksList from '../../components/related-links-list';
var RelatedLinksResolvedView = function RelatedLinksResolvedView(_ref) {
  var _ref$incomingLinks = _ref.incomingLinks,
    incomingLinks = _ref$incomingLinks === void 0 ? [] : _ref$incomingLinks,
    _ref$outgoingLinks = _ref.outgoingLinks,
    outgoingLinks = _ref$outgoingLinks === void 0 ? [] : _ref$outgoingLinks;
  return jsx(Stack, {
    space: "space.150"
  }, jsx(AnalyticsContext, {
    data: {
      component: 'relatedLinksIncoming'
    }
  }, jsx(RelatedLinksList, {
    urls: incomingLinks,
    title: messages.related_links_found_in,
    testId: "incoming-related-links-list"
  })), jsx(AnalyticsContext, {
    data: {
      component: 'relatedLinksOutgoing'
    }
  }, jsx(RelatedLinksList, {
    urls: outgoingLinks,
    title: messages.related_links_includes_links_to,
    testId: "outgoing-related-links-list"
  })));
};
export default RelatedLinksResolvedView;